<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" :rules="rules" label-width="100px">
            <el-form-item label="手机号：" prop="phone">
                <el-input
                    maxlength='11'
                    style="width: 300px;"
                    placeholder="请输入手机号"
                    v-model="formData.phone"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="verify_code">
                <el-input
                    maxlength='6'
                    style="width: 300px;"
                    class="input-ele2"
                    type="text"
                    v-model="formData.verify_code"
                    name="code"
                    placeholder="输入验证码"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
                <div class="yzm_btn" @click="obtainVerification()">{{txt}}</div>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入密码"
                    show-password
                    v-model="formData.password"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="企业名称：" prop="company">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入企业名称"
                    v-model="formData.company"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
            <el-form-item label="邮箱：">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入邮箱"
                    v-model="formData.email"
                    @keyup.enter.native="submitForm('formData')"
                ></el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
        <el-button
            style="float:right;margin-left:6px;"
            size="mini"
            type="danger"
            plain
            @click="handleClose"
        >取 消</el-button>
        <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/auth/register";
import { isvalidMobile } from "@/utils/validate";
export default {
    data() {
        const validateverify_code = (rule, value, callback) => {
            if (value.length < 4) {
                callback(new Error("验证码长度不要小于4位数"));
            } else {
                callback();
            }
        };
        const validatepassword = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码长度不要小于6位数"));
            } else {
                callback();
            }
        };
        const validateQMobile = (rule, value, callback) => {
            if (!isvalidMobile(value)) {
                callback(new Error("请输入正确的电话号码"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                phone: [
                    {
                        required: true,
                        validator: validateQMobile,
                        trigger: "blur"
                    }
                ],
                verify_code: [
                    {
                        required: true,
                        validator: validateverify_code,
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        validator: validatepassword,
                        trigger: "blur"
                    }
                ],
                company: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "blur"
                    }
                ]
            },
            disabled: false,
            formData: {
                email: "",
                password: "",
                verify_code: ""
            },
            txt: "获取验证码",
            loading: false,
            isshow: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true;
                    api.phone_register(this.formData)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 关闭窗口, 刷新列表
                                this.$message({
                                    message: "注册用户成功",
                                    type: "success"
                                });
                                this.handleClose();
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        //获取验证码
        obtainVerification() {
            if (this.disabled || this.isshow) {
                return;
            }
            if (!isvalidMobile(this.formData.phone)) {
                return this.$message.error("请输入正确的手机号");
            }
            const obj = {};
            obj.phone = this.formData.phone;
            this.isshow = true;
            api.send_verify_code(obj).then(res => {
                if (res.code == 0) {
                    this.timeOut();
                    this.isshow = false;
                } else {
                    this.isshow = false;
                    return this.$message.error(res.message);
                }
            });
        },
        //注册验证码的60S
        timeOut() {
            this.disabled = true;
            let num = 60;
            this.txt = num + "s";
            const nt = setInterval(() => {
                if (num <= 0) {
                    clearInterval(nt);
                    this.txt = "重新获取";
                    this.disabled = false;
                } else {
                    num--;
                    this.txt = num + "s";
                }
            }, 1000);
        },
        // 关闭弹窗
        handleClose() {
            this.loading = false;
            this.$emit("close-callback");
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/.el-checkbox {
    margin-right: 5px !important;
}

.input-ele2 {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
        background: white;
        // background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: #444;
        height: 47px;
        // &:-webkit-autofill {
        //   -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        //   -webkit-text-fill-color: #fff !important;
        // }
    }
}
.yzm_btn {
    width: 80px;
    font-size: 12px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 0px;
    line-height: 38px;
    border-radius: 0 6px 6px 0;
    text-align: center;
    color: #fff;
    background: #107bc5;
    cursor: pointer;
    border: none;
}
</style>
